var map = {
	"./No-Image-Placeholder.png": 853,
	"./admin-image-logo.png": 27564,
	"./barCode.png": 48746,
	"./box1-img.png": 77938,
	"./box10-img.png": 58421,
	"./box2-img.png": 69241,
	"./box3-img.png": 31181,
	"./box4-img.png": 63530,
	"./box5-img.png": 72651,
	"./box6-img.png": 46492,
	"./box7-img.png": 26098,
	"./box8-img.png": 96822,
	"./box9-img.png": 48086,
	"./candidate.png": 21029,
	"./fail.png": 91372,
	"./favicon.png": 24775,
	"./homeLogo.png": 35229,
	"./instructions.png": 41047,
	"./logo.png": 66949,
	"./no-signature.png": 99110,
	"./pdf-logo.png": 36261,
	"./photo.png": 8412,
	"./signature.png": 77433,
	"./success.png": 88296,
	"./ukpsc logo.png": 43352,
	"./upload_photo.png": 70716,
	"./upload_sign.png": 10399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92715;